import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=9c05f8a2&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=9c05f8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c05f8a2",
  null
  
)

export default component.exports